import { requestStatusLabelHelper } from 'helpers';
import { formatMoney } from 'helpers/moneyFormatter';

export const mapRequests = (requests) =>
  requests.map((request) => ({
    ...request,
    statusId: request.status,
    status: requestStatusLabelHelper(request.status),
    total_price: formatMoney(request.total_price),
  }));
